import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  navbarSettings: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Donor Hub Login Info');
  },

  model() {
    let record = get(this.modelFor('funds.fund.more.donor-hub'), 'record');
    if (!record) {
      record = this.store.createRecord('tnt-fund');
    }
    return {
      record,
    };
  },
});
